import { Box, Stack, styled, Typography } from '@mui/material';
import {
  BaseEdge,
  Edge,
  EdgeLabelRenderer,
  EdgeProps,
  getBezierPath,
  getSmoothStepPath,
} from '@xyflow/react';
import { StatusWorkflowActionType } from '../../../services/describeWorkflowUtils';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { useTranslation } from 'react-i18next';
import { WorkflowActionType } from '../../../data/models/workflow.model';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { memo } from 'react';

const PREFIX = 'WorkflowBranchingEdge';

const classes = {
  container: `${PREFIX}-container`,
};

const StyledBox = styled(Box)(({ theme }) => ({
  position: 'absolute',
  backgroundColor: 'white',
}));

type CustomEdgeData = {
  label?: string;
};

type CustomEdge = Edge<CustomEdgeData, 'custom'>;

const WorkflowBranchingEdge = ({
  id,
  sourceX,
  sourceY,
  sourcePosition,
  targetX,
  targetY,
  targetPosition,
  data,
}: EdgeProps<CustomEdge>) => {
  const { t } = useTranslation('common');
  const stepParams = {
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  };
  const [edgePath] = getSmoothStepPath(stepParams);
  return (
    <>
      <BaseEdge id={id} path={edgePath} />
      <EdgeLabelRenderer>
        {data?.label && (
          <StyledBox
            sx={{
              transform: `translate(-50%, -100%) translate(${targetX}px, ${targetY}px)`,
            }}>
            <Typography variant="body2">{data.label}</Typography>
          </StyledBox>
        )}
      </EdgeLabelRenderer>
    </>
  );
};

export default memo(WorkflowBranchingEdge);
